import { reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { useTour } from '@orion.ui/orion';

type Props = SetupProps<typeof TourTimeTicketReleaseNoteSetupService.props>

export default class TourTimeTicketReleaseNoteSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	readonly _tourTimeTicketReleaseNote = ref<OrionTour>();

	private readonly state = reactive({
		hasData: undefined as Undef<number>,
		isLaunched: false,
	});

	get hasData () { return this.state.hasData; }
	get isLaunched () { return this.state.isLaunched; }

	constructor () {
		super();
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourTimeTicketReleaseNote', this._tourTimeTicketReleaseNote.value);

		this.registerBusEvent('time-ticket-weeks-loaded', (data) => {
			this.state.hasData = data;
			this.state.isLaunched = true;
		});
	}

	firstIntegratedCircle () {
		const currentCardIntegratedDiv = document.querySelector(`
			.time-ticket-week-card--current
			> .orion-card__body
			> .week__circles
			> .time-ticket-week-circle:last-child`);

		return currentCardIntegratedDiv
			? currentCardIntegratedDiv
			: document.querySelector(`
				.time-ticket-week-card
				> .orion-card__body
				> .week__circles
				> .time-ticket-week-circle:last-child`);
	}
}
